import { IntrasoftJwtTokens, IntrasoftJwtPayload } from "@intrasoft/auth-core";
import { refreshToken, decodeJwt } from "@intrasoft/auth-core";

/**
 * Decrypts an authentication token.
 *
 * @param {string} access - The access token to be decrypted.
 * @returns {Promise<IntrasoftJwtPayload>} A promise that resolves to the decoded JWT.
 */
export async function decryptAuthToken(
  access: string
): Promise<IntrasoftJwtPayload> {
  return await decodeJwt(access);
}

/**
 * Revalidates the tokens using the provided refresh token.
 *
 * This function takes a refresh token and uses it to obtain a new set of tokens
 *
 * @param {string} refresh - The refresh token used to obtain new tokens.
 * @returns {Promise<IntrasoftJwtTokens>} A promise that resolves to the new tokens.
 */
export async function revalidatedTokens(
  refresh: string
): Promise<IntrasoftJwtTokens> {
  return await refreshToken(refresh);
}
